<template>
  <button
    class="radio-button-knob-component"
    :style="`
      cursor: ${is_disabled ? 'default' : 'pointer'};
      background-color: ${is_disabled ? '#E0E0E0' : '#FFF'}
    `"
    @click="handleClick()"
  >
    <div :class="`${is_disabled ? 'radio-button-knob-component-disabled' : 'radio-button-knob-component-enabled'}`">
      <!-- FULL CIRCLE -->
      <div
        v-if="is_on && !is_half"
        :class="`radio-button-knob-component-full`"
      />

      <!-- HALF CIRCLE -->
      <div
        v-if="!is_on && is_half"
        class="radio-button-knob-component-half"
      >
        <div :class="`radio-button-knob-component-left`"/>
        <div :class="`radio-button-knob-component-right`"/>
      </div>
    </div>
  </button>
</template>

<script>
  export default {
    props: [
      'is_on',
      'is_half',
      'is_disabled',
    ],

    methods: {
      handleClick() {
        if(!this.is_disabled) {
          this.$emit('radioButtonKnobClicked')
        }
      },
    },
  }
</script>

<style>
.radio-button-knob-component {
  width: 16px;
  height: 16px;
  background-color: #FFF;
  border-radius: 8px;
  border: 1px solid #AAA;
  display: flex;
  justify-content: center;
  align-items: center;
}
.radio-button-knob-component-full {
  width: 8px;
  height: 8px;
  border-radius: 4px;
}
.radio-button-knob-component-half {
  display: flex;
}
.radio-button-knob-component-left {
  width: 4px;
  height: 8px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.radio-button-knob-component-right {
  width: 4px;
  height: 8px;
  background-color: #FFF;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right: 1px solid;
}
.radio-button-knob-component-enabled > .radio-button-knob-component-full,
.radio-button-knob-component-enabled > .radio-button-knob-component-half > .radio-button-knob-component-left {
  background-color: #090909;
}
.radio-button-knob-component-enabled > .radio-button-knob-component-half > .radio-button-knob-component-right {
  background-color: #FFF; /* background-color as in line 6 */
  border-color: #090909;
}
.radio-button-knob-component-disabled > .radio-button-knob-component-full,
.radio-button-knob-component-disabled > .radio-button-knob-component-half > .radio-button-knob-component-left {
  background-color: #777;
}
.radio-button-knob-component-disabled > .radio-button-knob-component-half > .radio-button-knob-component-right {
  background-color: #E0E0E0; /* background-color as in line 6 */
  border-color: #777;
}
</style>
